import {EntityModel} from '../../../core/model/entity.model';

export class Department extends EntityModel {
  public name?: string;
  public departmentLevel?: number;
}
